export const getLocaleFromSlug = (slug) => {
  if (slug.startsWith('/en')) return 'en';
  if (slug.startsWith('/de')) return 'de';
  if (slug.startsWith('/fr')) return 'fr';

  return 'nl';
};
